import { irisTrackerService } from 'packages/common/services';

const origin = 'PERSONNEL_DEPARTMENT';
const catalogName = 'personnelDepartment';

export const clickGenerateReportTracker = ({ name, type } = {}) => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.reportModal,
    origin,
  }).setAction(catalog.actions.clickGenerateReport)
    .setAdditionalInfo({ name, type })
    .send();
};
